import { NgModule } from '@angular/core';
import { NgxsModule } from '@ngxs/store';

import { OnboardingStoreState } from './store';

@NgModule({
  imports: [
    NgxsModule.forFeature([ OnboardingStoreState ])
  ]
})
export class OnboardingWebSharedStoreModule {}
